import React, { useContext } from "react";
import FormBuilderContext from "../contexts/FormBuilderContext";

function useFormBuilderContext() {
    const context = useContext(FormBuilderContext);
    return context;
}

export default useFormBuilderContext;
